import { cartLinesStyles as styles } from "@insite/content-library/Widgets/Cart/CartLines";
import { css } from "styled-components";

styles.headerWrapper = {
    ...styles.headerWrapper,
    css: css`
        ${styles.headerWrapper?.css}

        border-bottom: 0;
    `,
};

styles.header = {
    ...styles.header,
    condensedViewCheckbox: {
        css: css`
            display: none;
        `,
    },
};
